import { createSelector } from "@reduxjs/toolkit";
import { getCanonicalUrlFromCategoryDetailsByLocale } from "../category/selectors";
import { queryStringToObject } from "../../../helpers/queryStringToObject";

const selectRouter = (state) => state?.router;

const withParsedQuery = (location) => {
  if (!location || typeof location !== "object") {
    return location;
  }

  return location.search && !location.query
    ? { ...location, query: queryStringToObject(location.search) }
    : location;
};

const selectLocationFromState = createSelector([selectRouter], (router) => {
  if (!router) {
    return;
  }
  if (router.locationBeforeTransitions) {
    return withParsedQuery(router.locationBeforeTransitions);
  }

  return withParsedQuery(router.location);
});

const getLocationFromBrowserHistory = () => {
  if (CLIENT) {
    const { history } = require("../../../client/history");

    const location = history.location;
    const locationWithQuery = {
      ...location,
      query: queryStringToObject(location.search),
    };

    return locationWithQuery;
  }
};

export const getLocation = (state) => {
  const locationFromState = selectLocationFromState(state);
  if (locationFromState) {
    return locationFromState;
  }

  return getLocationFromBrowserHistory();
};

const selectLocation = (state) => getLocation(state);
const selectCanonicalUrl = (state) =>
  getCanonicalUrlFromCategoryDetailsByLocale(state);

export const getOriginalCurrentPriceRange = createSelector(
  [selectLocation],
  (location) => {
    const { currentpricerange = "" } = location?.query || {};

    if (currentpricerange === "") return {};

    return currentpricerange
      .split("-")
      .map(Number)
      .reduce((min, max) => ({ min, max }));
  },
);

export const getCanonicalPath = createSelector(
  [selectCanonicalUrl, selectLocation],
  (canonicalUrlFromApi, location) => {
    if (canonicalUrlFromApi !== "") {
      return new URL(canonicalUrlFromApi).pathname;
    }

    return location?.pathname;
  },
);
